import { Injectable } from '@angular/core'

import { AppliedRuleFinderCommonFilterHandler } from './handlers/applied-rule-finder-common-filter-handler'
import { FundRuleName } from './rules/fund-rule-name'
import { IFilterHandler } from './rules/ifilter-handler'
import { RuleBaseFundRetrievalCommonFilterHandler } from './rules/rule-base-fund-retrieval-common-filter-handler'

@Injectable({
  providedIn: 'root',
})
export class FilterHandlerFactory {
  private static ruleBaseFundRetrievalCommonFilterHandler: IFilterHandler =
    new RuleBaseFundRetrievalCommonFilterHandler()
  private static appliedRuleFinderCommonFilterHandler: IFilterHandler =
    new AppliedRuleFinderCommonFilterHandler()
  private filterHandlerMap: Map<string, IFilterHandler> = new Map<
    string,
    IFilterHandler
  >()

  constructor() {
    // Product type
    this.filterHandlerMapForProductType()
    // Equity
    this.filterHandlerMapForEquity()
    // Fixed Income
    this.filterHandlerMapForFixedIncome()
    //Multi Asset
    this.filterHandlerMapForMultiAsset()
    // Cash Equivalent
    this.filterHandlerMapForCashEquivalent()
    // Strategy
    this.filterHandlerMapForStrategy()
  }

  private filterHandlerMapForProductType() {
    this.filterHandlerMap.set(
      FundRuleName.PRODUCT_TYPE_COLLECTIVE_TRUST,
      FilterHandlerFactory.appliedRuleFinderCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.PRODUCT_TYPE_MUTUAL_FUND,
      FilterHandlerFactory.appliedRuleFinderCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.PRODUCT_TYPE_ETF,
      FilterHandlerFactory.appliedRuleFinderCommonFilterHandler,
    )
  }

  private filterHandlerMapForEquity() {
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_US,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_LARGE,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_INTERNATIONAL,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_DEVELOPED,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_EMERGING,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_GLOBAL,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_NON_US,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_MID,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_SMALL,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_INDEX,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_ACTIVE,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_BLEND,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_GROWTH,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.EQUITY_VALUE,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
  }

  // eslint-disable-next-line max-statements
  private filterHandlerMapForFixedIncome() {
    this.filterHandlerMap.set(
      FundRuleName.FI_US,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_INTERNATIONAL,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_DEVELOPED,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_EMERGING,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_GLOBAL,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_NON_US,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_LONG,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_INTERMEDIATE,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_SHORT,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_INDEX,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_ACTIVE,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_BELOW_INV_GRADE,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_INV_GRADE_CORP,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_MUNI,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_TREASURY_AGENCY,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FI_MULTI_SECTOR,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
  }

  private filterHandlerMapForMultiAsset() {
    this.filterHandlerMap.set(
      FundRuleName.MULTI_ASSET_US,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.MULTI_ASSET_INTL,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.MULTI_ASSET_BALANCE,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.MULTI_ASSET_TARGET_ALLOCATION,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.MULTI_ASSET_TARGET_DATE,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
  }

  private filterHandlerMapForCashEquivalent() {
    this.filterHandlerMap.set(
      FundRuleName.CASH_EQUIVALENTS_MUNI,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.CASH_EQUIVALENTS_TAXABLE,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.CASH_EQUIVALENTS_STABLE_VALUE,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
  }

  private filterHandlerMapForStrategy() {
    this.filterHandlerMap.set(
      FundRuleName.DIVIDEND_STRATEGY,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.ESG_STRATEGY,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.FACTOR_DRIVEN_STRATEGY,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
    this.filterHandlerMap.set(
      FundRuleName.SECTOR_SPECIALITY_STRATEGY,
      FilterHandlerFactory.ruleBaseFundRetrievalCommonFilterHandler,
    )
  }

  getInstance(filterSelection: FundRuleName): IFilterHandler {
    return this.filterHandlerMap.get(filterSelection)
  }
}
